module.exports = __webpack_public_path__ + "static/20210918_180352-9880c76866db39fe51e4701f6f7e834c.jpg";